<template>
  <q-card :flat="$q.screen.lt.md">
    <q-card-section class="text-center q-pa-xs" v-if="items && items.length>0">
      <q-avatar dir="ltr" size="lg" color="indigo" text-color="white">
        <span class="text-subtitle2"> {{ items[items.length - 1].ConversionRate }}</span>
      </q-avatar>
      <q-icon
          v-if="items.length>1"
          :name="items[items.length - 1].ConversionRate > items[items.length - 2].ConversionRate?'arrow_upward':'south'"
          :color="items[items.length - 1].ConversionRate > items[items.length - 2].ConversionRate?'green':'red'"
          size="lg">
        <q-tooltip>
          نسبت به ماه گذشته
        </q-tooltip>
      </q-icon>
      <q-space/>
      <q-chip clickable color="brown" text-color="white" square label="نرخ تبدیل"/>
    </q-card-section>
    <q-tooltip content-class="bg-transparent text-black">
      <q-card flat bordered>
        <q-card-section>
          <LineChart :items="items" :data="this.items.map(item => item.ConversionRate)"
                     title="مقایسه نرخ تبدیل فروش ماهیانه"/>
        </q-card-section>
      </q-card>
    </q-tooltip>
  </q-card>
</template>

<script>
import LineChart from "@/components/OrderTrace/LineChart";

export default {
  name: "ConversionRate",
  components: {LineChart},
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      orderChartOptions: {
        chart: {
          id: 'ConversionRate',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'مقایسه نرخ تبدیل ماهیانه در سال جاری',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'مقدار',
        data: []
      }],
    }
  },
  created() {
    this.orderChartSeries = [{
      data: this.items.map(item => item.SaleRate)
    }]
  }
}
</script>

<style scoped>

</style>